import styled from "styled-components";
export const Card = styled.div`
  width: 100%;
  padding: 15px;
  /* height: 400px; */
  background: ${({ theme }) => theme.white};
  box-shadow: ${({ theme }) => theme.boxShadow2};
  border-radius: 10px;
`;
